<template>
    <div>

        <v-card>
            <v-card-title>Listado de distancias</v-card-title>
            <v-card-text>

                <botonera :botones="botones" alinear="right" @crear="dialog = !dialog" @cargar="upload = !upload"></botonera>


            </v-card-text>
        </v-card>


        <datatable :cabeceras="distanciasListHeaders" :items="distanciasListBody" titulo="Listado de Distancias"
            label="Escriba Para buscar Distancia" icono="list" color_icono="azul" :acciones="['editar', 'eliminar']"
            @editar="editDistancia($event)" @eliminar="deleteDistancia($event)">
        </datatable>

        <!-- <v-data-table 
        :headers="distanciasListHeaders"
        :items="distanciasListBody"
        class="elevation-1"
        no-data-text="No hay distancias"
        :search="search"
    >
      <template v-slot:[`item.actions`]="{item}">
        <v-tooltip left>
          <template v-slot:activator="{ on }">
            <v-icon
              medium
              class="mr-2"
              @click="editDistancia(item)"
              v-on="on"
            >
              mdi-pencil
            </v-icon>
          </template>
<span>Editar datos del Distancia</span>
</v-tooltip>
<v-tooltip left>
    <template v-slot:activator="{ on }">
            <v-icon
                medium
                @click="deleteDistancia(item)"
                v-on="on"
            >
            mdi-delete
            </v-icon>
          </template>
    <span>Dar de baja Distancia</span>
</v-tooltip>
</template>
</v-data-table> -->

        <!-- Modal Nuevo Distancia -->
        <v-dialog v-model="dialog" width="800px" @click:outside="closeModal">
            <v-card>
                <v-card-title class="blue darken-1">{{ title }}</v-card-title>
                <v-card-text>
                    <v-row class="mx-2">
                        <v-col cols="4">
                            <v-select prepend-icon="mdi-factory" v-model="form.tipo_origenes_id" :items="tipos"
                                item-text="nombre" item-value="id" label="Tipo de Origen" color="blue darken-3"
                                persistent-hint>
                            </v-select>
                        </v-col>
                        <v-col cols="8">
                            <v-select v-if="form.tipo_origenes_id === 1" prepend-icon="mdi-factory"
                                v-model="form.origen_id" :items="centros" item-text="empresa_centro" item-value="id"
                                label="Centro de Cultivo" color="blue darken-3" persistent-hint>
                            </v-select>
                            <v-select v-if="form.tipo_origenes_id === 2" prepend-icon="mdi-factory"
                                v-model="form.origen_id" :items="acopios" item-text="nombre" item-value="id"
                                label="Centro de Acopio" color="blue darken-3" persistent-hint>
                            </v-select>
                            <v-select v-if="form.tipo_origenes_id === 3" prepend-icon="mdi-factory"
                                v-model="form.origen_id" :items="muelles" item-text="nombre" item-value="id"
                                label="Muelle/Bahía" color="blue darken-3" persistent-hint>
                            </v-select>
                        </v-col>
                        <v-col cols="4">
                            <v-select prepend-icon="mdi-factory" v-model="form.tipo_destinos_id" :items="tipos"
                                item-text="nombre" item-value="id" label="Tipo de Destino" color="blue darken-3"
                                persistent-hint>
                            </v-select>
                        </v-col>
                        <v-col cols="8">
                            <v-select v-if="form.tipo_destinos_id === 1" prepend-icon="mdi-factory"
                                v-model="form.destino_id" :items="centros" item-text="empresa_centro" item-value="id"
                                label="Centro de Cultivo" color="blue darken-3" persistent-hint>
                            </v-select>
                            <v-select v-if="form.tipo_destinos_id === 2 && form.tipo_origenes_id != 2"
                                prepend-icon="mdi-factory" v-model="form.destino_id" :items="acopios" item-text="nombre"
                                item-value="id" label="Centro de Acopio" color="blue darken-3" persistent-hint>
                            </v-select>
                            <v-select v-if="form.tipo_destinos_id === 3 && form.tipo_origenes_id != 3"
                                prepend-icon="mdi-factory" v-model="form.destino_id" :items="muelles" item-text="nombre"
                                item-value="id" label="Muelle/Bahía" color="blue darken-3" persistent-hint>
                            </v-select>
                        </v-col>
                        <v-col class="align-center justify-space-between" cols="4">
                            <v-text-field prepend-icon="mdi-barcode" placeholder="Millas" v-model="form.millas">
                            </v-text-field>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="closeModal">Cerrar</v-btn>
                    <v-btn color="primary" @click="saveDistancia">Grabar</v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>
        <!-- / Modal -->

        <!-- Modal upload -->
        <v-dialog v-model="upload" width="600px">
            <v-card>
                <v-card-title class="green darken-1">
                    Subir listado de distancias desde excel
                </v-card-title>
                <v-card-text>
                    <v-row class="mx-2">
                        <v-file-input v-model="file" accept=".xls, .xlsx" label="Archivo Excel"></v-file-input>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-btn @click="upload = false">Cancelar</v-btn>
                    <v-btn color="primary" @click="uploadDistancias">Subir</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- / Modal -->

        <v-snackbar v-model="snackbar" :timeout="5000" :color="color">
            {{ validation_message }}

            <template v-slot:action="{ attrs }">
                <v-btn color="white" text v-bind="attrs" @click="snackbar = false">
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'

export default {
    data: () => ({
        title: 'Nueva Distancia',
        color: 'green',
        snackbar: false,
        errors: [],
        validation_message: '',
        search: null,
        file: null,
        dialog: false,
        upload: false,
        acopios: [],
        centros: [],
        muelles: [],
        //empresas: [],
        distanciaIndex: -1,
        form: {
            tipo_origenes_id: null,
            tipo_destinos_id: null,
            origen_id: null,
            destino_id: null,
            millas: null,
            users_id: null
        },
        tipos: [
            { id: 1, nombre: "Centro de Cultivo" },
            { id: 2, nombre: "Centro de Acopio" },
            { id: 3, nombre: "Muelle/Bahía" }
        ],
        distanciasListHeaders: [
            {
                text: 'Id',
                align: 'center',
                sortable: true,
                value: 'id',
                class: "blue-grey darken-4 white-text"
            },
            {
                text: 'Tipo 1',
                align: 'center',
                sortable: true,
                value: 'tipo_origen',
                class: "blue-grey darken-4 white-text"
            },
            {
                text: 'Punto 1',
                align: 'center',
                sortable: true,
                value: 'punto_uno',
                class: "blue-grey darken-4 white-text"
            },
            {
                text: 'Tipo 2',
                align: 'center',
                sortable: true,
                value: 'tipo_destino',
                class: "blue-grey darken-4 white-text"
            },
            {
                text: 'Punto 2',
                align: 'center',
                sortable: true,
                value: 'punto_dos',
                class: "blue-grey darken-4 white-text"
            },
            {
                text: 'Millas',
                align: 'center',
                sortable: true,
                value: 'millas',
                class: "blue-grey darken-4 white-text"
            },
            {
                text: 'Acciones',
                align: 'center',
                sortable: false,
                value: 'actions',
                class: "blue-grey darken-4 white-text"
            },
        ],
        distanciasListBody: [],
        botones: [
            { boton: 'crear', tooltip: 'Nueva Distancia' },
            {boton:'cargar',tooltip:'Carga Masiva'},
            //{boton:'eliminar',tooltip:'Borrar Todo'}
        ]
    }),
    async mounted() {
        await this.loadAcopios();
        await this.loadCentros();
        await this.loadMuelles();
        await this.loadDistancias();
    },
    methods: {
        async loadAcopios() {
            let url = `${this.base_url}acopios`;
            await this.axios.get(url, this.headers).then((response) => {
                this.acopios = response.data.filter(a => a.mostrar == 1);
            }).catch((error) => {
                console.log(error);
            });
        },
        async loadCentros() {
            let url = `${this.base_url}centros`;
            await this.axios.get(url, this.headers).then((response) => {
                this.centros = response.data.filter(a => a.mostrar == 1);
            }).catch((error) => {
                console.log(error);
            });
        },
        async loadMuelles() {
            let url = `${this.base_url}muelles`;
            await this.axios.get(url, this.headers).then((response) => {
                this.muelles = response.data.filter(a => a.mostrar == 1);
            }).catch((error) => {
                console.log(error);
            });
        },
        async loadDistancias() {
            this.mostrarLoading('Cargando listado de distancias...')
            let url = `${this.base_url}distancias`;
            await this.axios.get(url, this.headers).then((response) => {
                this.distanciasListBody = response.data;
                this.ocultarLoading()
            }).catch((error) => {
                console.log(error);
                this.ocultarLoading()
            });
        },
        async saveDistancia() {
            
            let body = {
                tipo_origenes_id: this.form.tipo_origenes_id,
                tipo_destinos_id: this.form.tipo_destinos_id,
                origen_id: this.form.origen_id,
                destino_id: this.form.destino_id,
                millas: this.form.millas
            };
            let url = `${this.base_url}savedistancias`;
            await this.axios.post(url, body, this.headers).then((response) => {
                console.log(response)
                    //this.distanciasListBody.push(response.data);
                    this.showSnackBar(false);
                    this.loadDistancias();

                }).catch((error) => {
                    this.errors = error.response.data;
                    this.validation_message = this.errors.join();
                    this.showSnackBar(true);
                });
            this.cleanForm();
        },
        editDistancia(item) {
            console.log(item)
            /*this.distanciaIndex = this.distanciasListBody.indexOf(item);
            this.distancia = Object.assign({}, item);
            this.distancia.empresa = item.centro.empresa;
            this.dialog = true;
            this.loadCentros();
            this.title = "Editar Distancia";*/
        },
        async deleteDistancia(item) {
            this.$confirm('Desea borrar este distancia?').then(res => {
                if (res) {
                    let url = `${this.base_url}distancias/${item.id}`;
                    this.axios.delete(url, this.headers).then((response) => {
                        console.log(response);
                        const index = this.distanciasListBody.indexOf(item);
                        this.distanciasListBody.splice(index, 1);
                        this.showSnackBar(false);
                    }).catch((error) => {
                        this.validation_message = error;
                        this.showSnackBar(true);
                    });
                }
            });
        },
        showSnackBar(error) {
            if (error) {
                this.color = 'red';
            } else {
                this.color = 'green';
                this.validation_message = "Ejecutado exitosamente!";
            }
            this.snackbar = true;
        },
        closeModal() {
            this.cleanForm();
            this.dialog = false;
            this.error = null;
            this.title = "Nueva Distancia";
        },
        cleanForm() {
            this.distancia.id = 0;
            this.distancia.acopio = null;
            this.distancia.centro = {};
            this.distancia.millas = "";
            this.dialog = false;
        },
        async uploadDistancias() {
            this.headers.headers['Content-Type'] = "multipart/form-data";
            let url = `${this.base_url}uploads/distancias`;
            let formData = new FormData();
            formData.append("excel", this.file);
            await this.axios.post(url, formData, this.headers).then((response) => {
                console.log(response.data.data);
                this.file = null;
                this.upload = false;
                this.loadDistancias();
                this.showSnackBar(false);
            }).catch((response) => {
                if (response.success == false && response.message == "Validation Error") {
                    this.validation_message = "Error de validación";
                    this.showSnackBar(true);
                }
            });
        },
        ...mapMutations(['actualizarBaseUrl', 'mostrarLoading', 'ocultarLoading']),
    },
    computed: {
        ...mapState(['loading', 'base_url', 'headers']),

    },
    components: {

    }
}
</script>